module.exports = __webpack_public_path__ + "img/section2NewModel.051da95f.png";